import { render } from "./WeekGroupEdit.vue?vue&type=template&id=50f3ef0e&scoped=true"
import script from "./WeekGroupEdit.vue?vue&type=script&lang=js"
export * from "./WeekGroupEdit.vue?vue&type=script&lang=js"

import "./WeekGroupEdit.vue?vue&type=style&index=0&id=50f3ef0e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src4026252432/src/luca_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50f3ef0e"]])

export default __exports__